export const getStoredResponse = () => {
  if (typeof localStorage === "undefined") {
    return {};
  }
  const stored = localStorage.getItem("response");
  if (!stored) {
    return {};
  }
  try {
    const parsed = JSON.parse(stored);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
      return {};
    }
    return parsed;
  } catch {
    return {};
  }
};
